import type { ReactNode } from 'react'
import { cn } from '../../utils/cn'

export type BadgeTone = 'neutral' | 'primary' | 'success' | 'error' | 'warning'

/* Muted status colours: the brand write-up explicitly rules out neon. Success
   and warning have no M3 role in this palette, so they borrow tertiary/secondary. */
const TONES: Record<BadgeTone, string> = {
  neutral: 'bg-surface-container-high text-on-surface-variant',
  primary: 'bg-primary-fixed text-on-primary-fixed-variant',
  success: 'bg-tertiary-fixed text-on-tertiary-fixed-variant',
  error: 'bg-error-container text-on-error-container',
  warning: 'bg-secondary-fixed text-on-secondary-fixed-variant',
}

export interface BadgeProps {
  children: ReactNode
  tone?: BadgeTone
  /** Material Symbols glyph name shown before the label. */
  icon?: string
  className?: string
}

export function Badge({ children, tone = 'neutral', icon, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-3 py-1 font-label-caps text-label-caps uppercase',
        TONES[tone],
        className,
      )}
    >
      {icon && <span className="material-symbols-outlined text-[14px]">{icon}</span>}
      {children}
    </span>
  )
}
